import gumdamar1 from "../assets/gum-damar-1.jpeg"
import gumdamar2 from "../assets/gum-damar-2.jpeg"
import gumdamar3 from "../assets/gum-damar-3.jpeg"

const DammarGumData = [
    {
        imgsrc: gumdamar1, 
        title: "Gum Damar AC Quality",
        text: "Gum Damar AC Quality is a quality grade of Gum Damar. The AC quality has a lighter white color and the structure range 5 to 7 cm. Due to the different color gradation between the picture and the real item, the AC and CK quality may have the same color in the picture."
    },
    {
        imgsrc: gumdamar2, 
        title: "Gum Damar CK Quality",
        text: "Gum Damar CK Quality is a quality grade of Gum Damar. The CK quality has the same structure as the AC quality, which is 5 to 7 cm. However, the CK type has a darker color than the AC quality."
    },
    {
        imgsrc: gumdamar3, 
        title: "Damar Mata Kucing",
        text: "Damar Mata Kucing is a variation of damar gum. Damar mata kucing is commonly used as inks, paints and mixed ingredients for beverages. In addition, Damar Mata Kucing can also be used as an anti-fungal and anti-termite drug."
    }
]

export default DammarGumData;





